import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getPatientAnalytic = async (filter) => {
  const { startDate, endDate } = filter;

  if (startDate && endDate) {
    const query = Object.entries(filter)
      .filter(([_, v]) => v)
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join("&");

    let url = endpoints.dashboard.patientAnalytic;
    url += query ? `?${query}` : "";

    const { data } = await api.get(url);
    return data;
  }
};

export const getPatientBatteryInformation = async (patientId, reportId) => {
  let url = interpolate(endpoints.patient.batteryInformation, {
    patientId,
  });

  if (reportId) {
    url = `${url}?reportId=${reportId}`;
  }

  const { data } = await api.get(url);
  return data;
};
